const Types = {
  WX_APP_ID: 'wx_app_id',
  U_ID: 'u_id',
  OPEN_ID: 'open_id',
  GAME_USER_NAME: 'game_user_name',
  // 签到活动相关
  ACT_SIGNIN_ONCE: 'act_signin_once',
  wxAuthQuery: 'wxAuthQuery',
  IP_ADDR: 'ip_addr'
}

/**
 * @param {*} typeName 键值常量名
 * @param {*} value 值
 */
export const storeSet = (typeName, value, stringify = false) => {
  try {
    if (!typeName || !Types[typeName] || !localStorage) return
    localStorage.setItem(Types[typeName], stringify ? JSON.stringify(value) : value)
  } catch (error) {
    console.log(error)
  }
}

/**
 * @param {*} typeName 键值常量名
 */
export const storeGet = (typeName, parse = false) => {
  try {
    if (!typeName || !Types[typeName] || !localStorage) return ''
    return parse ? JSON.parse(localStorage.getItem(Types[typeName])) : localStorage.getItem(Types[typeName])
  } catch (error) {
    return ''
  }
}

/**
 * @param {*} typeName 键值常量名
 */
export const storeDel = (typeName) => {
  try {
    if (!typeName || !Types[typeName] || !localStorage) return
    localStorage.removeItem(Types[typeName])
  } catch (error) {
    console.log(error)
  }
}
